import { ApolloError } from '@apollo/client';
import type { User } from '../types/GraphqlTypes';
import { useAuth } from '@zg-rentals/auth-comet';

type ErrorDetails = {
  userEmail?: User['email'];
  userToken?: User['userToken'];
  message?: string;
  stack?: string;
  name?: string;
  clientErrors?: ApolloError['clientErrors'];
  graphQLErrors?: ApolloError['graphQLErrors'];
};

export default () => {
  const { user } = useAuth();
  const { userToken, email } = user ?? {};

  const formatError = (err: ApolloError | Error | unknown) => {
    let errorDetails: ErrorDetails = {
      userEmail: email,
      userToken: userToken,
    };

    if (err instanceof Error) {
      errorDetails = {
        ...errorDetails,
        message: err.message,
        stack: err.stack,
        name: err.name,
      };
    }

    if (err instanceof ApolloError) {
      errorDetails = {
        ...errorDetails,
        clientErrors: err.clientErrors,
        graphQLErrors: err.graphQLErrors,
      };
    }

    return {
      error: errorDetails,
    };
  };

  return {
    formatError,
  };
};
